import React, { useEffect } from "react";
import "./FaqDetail.css";
import HeaderTarget from "../../components/HeaderTarget/HeaderTarget";
import FaqSearch from "../../components/FaqSearch/FaqSearch";
import arrowIcon from "./../../assets/arrow.png";
import FaqRightMenu from "../../components/FaqRightMenu/FaqRightMenu";

import { useParams } from "react-router-dom"; // URL parametrelerini almak için
import faqData from "../../api/faqdata"; // faqData'yı içe aktarıyoruz
import NotFound from "../NotFound/404";
import { formatPage } from "../../utils/formatPage";

import { useTranslation } from "react-i18next";
import { useSEO } from "../../context/SEOContext";

const FaqDetail = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("faq.meta.title"),
      description: t("faq.meta.description"),
      keywords: t("faq.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);

  const { faqUrl } = useParams(); // URL parametrelerinden faqUrl'yi alıyoruz

  // faqData'dan ilgili soruyu buluyoruz
  const faqDetail = faqData
    .flatMap((category) => category.faqs) // Bütün kategorilerdeki soruları birleştiriyoruz
    .find((faq) => formatPage(faq.question) === faqUrl); // İlgili soruyu buluyoruz

  if (!faqDetail) {
    return <NotFound />; // Eğer soru bulunmazsa hata mesajı
  }

  return (
    <>
      <HeaderTarget activePage="faq" />
      <section className="bgcolorpage pt-4 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mb-4 mt-5">
              <a href="/faq">
                <img
                  src={arrowIcon}
                  alt="arrowIcon"
                  width={20}
                  className="mb-3"
                />
              </a>
              <FaqSearch />
            </div>
            <div className="col-lg-7">
              <div className="bg-white p-5 pt-4 pb-4 fw-14">
                <h4 className="fw-light fs-3 mb-3 mt-3">
                  {faqDetail.question}
                </h4>
                <p>{faqDetail.answer}</p>
              </div>
            </div>
            <div className="col-lg-5">
              <FaqRightMenu />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqDetail;
